export type LeafLinkListProductsSearch = { brandId?: string; search?: string };

export function parseLeafLinkListProductsSearch(
  search: Record<string, unknown>,
): LeafLinkListProductsSearch {
  return {
    ...(typeof search.brandId === 'string' && search.brandId !== ''
      ? { brandId: search.brandId }
      : {}),
    ...(typeof search.search === 'string' && search.search !== '' ? { search: search.search } : {}),
  };
}
